import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useExport = () => {
  const { locale } = useLocale();
  const { mutate: exportStakeholders, isPending } = useAppMutation([QueryKey.STAKEHOLDERS_EXPORT], {
    mutationFn: ({ companyId }: { companyId: string }) =>
      ApiService.downloadFile(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'stakeholders', 'export'],
        },
        { locale },
      ),
  });
  return { exportStakeholders, isPending };
};
